const URLS = {
  V1: "https://devapi.orbitshift.ai/v1",
  ASSETS: "https://devapi.orbitshift.ai/assets",
  OS_LITE: "https://devapi.orbitshift.ai/v1/os_lite"
}

export default URLS
